module.exports = __webpack_public_path__ + "static/media/kenkohealth.be4c53be.svg";